const FORM = '.label-purchase';
const RATE_LIST = '#label-rate-list';

const buyButton = (form) => document.querySelector(`[form="${form.id}"][type="submit"]`);

const syncBuyButton = (form) => {
    const button = buyButton(form);

    if (!button) {
        return;
    }

    button.disabled = form.hasAttribute('data-requires-rate')
        && !form.querySelector('input[name="quoteRateId"]:checked');
};

const clearRates = (form) => {
    const rates = form.querySelector(RATE_LIST);

    if (rates) {
        rates.innerHTML = '';
    }
};

export const handleLabelPurchaseChange = (target) => {
    const form = target.closest?.(FORM);

    if (!form) {
        return;
    }

    if (!target.closest(RATE_LIST)) {
        clearRates(form);
    }

    syncBuyButton(form);
};

export const syncLabelBuyButton = (root) => {
    const form = root.closest?.(FORM) ?? root.querySelector?.(FORM);

    if (form) {
        syncBuyButton(form);
    }
};
